import Footer2 from './Footer2'
export default Footer2
